var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 6L6.33366 7.33333L9.33366 4.33333M12.3337 13V4.2C12.3337 3.0799 12.3337 2.51984 12.1157 2.09202C11.9239 1.71569 11.618 1.40973 11.2416 1.21799C10.8138 1 10.2538 1 9.13366 1H4.86699C3.74689 1 3.18683 1 2.75901 1.21799C2.38269 1.40973 2.07673 1.71569 1.88498 2.09202C1.66699 2.51984 1.66699 3.0799 1.66699 4.2V13L3.50033 11.6667L5.16699 13L7.00033 11.6667L8.83366 13L10.5003 11.6667L12.3337 13Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsIcon);
export default __webpack_public_path__ + "static/media/claims-icon.495f4a9e9303548a50c7237f902cfae6.svg";
export { ForwardRef as ReactComponent };